var render = function render(){var _vm=this,_c=_vm._self._c,_setup=_vm._self._setupProxy;return _c('div',[(!_vm.value)?[_c('v-btn',{on:{"click":_vm.createRule}},[_vm._v("Add rule")])]:[_c('RuleWrapper',{attrs:{"value":_vm.value},on:{"input":function($event){return _vm.$emit('input', $event)}}})]],2)
}
var staticRenderFns = []

export { render, staticRenderFns }